"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapMarker = exports.MapMarkerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var react_map_gl_1 = require("react-map-gl");
var map_marker_icon_1 = require("./map-marker-icon");
var map_popup_1 = require("./map-popup");
exports.MapMarkerDefaultProps = {
  scaleFactor: 10,
  maxSize: 40,
  anchor: 'bottom'
};
// -------- Styles -------->
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    position: relative;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    position: relative;\n  "])), theme_1.theme.COLOR('text'))
});
var MarkerIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    cursor: pointer;\n    position: relative;\n    opacity: 1.0;\n    &:hover {\n      .shp--map-marker-icon__fill {\n        fill: ", ";\n      }\n    }\n\n    ", "\n\n    ", "\n\n  "], ["\n    cursor: pointer;\n    position: relative;\n    opacity: 1.0;\n    &:hover {\n      .shp--map-marker-icon__fill {\n        fill: ", ";\n      }\n    }\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.COLOR('link-hover'), function (_a) {
    var zoom = _a.zoom;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), Math.min(zoom * 10, 40), Math.min(zoom * 10, 40));
  }, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      .shp--map-marker-icon__fill {\n        fill: ", ";\n      }\n    "], ["\n      .shp--map-marker-icon__fill {\n        fill: ", ";\n      }\n    "])), theme_1.theme.COLOR('link-hover'));
  })
});
var PopupStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme_1.theme.REMOVE_BUTTON_STYLE())
});
// -------- Components -------->
var My = {
  Body: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  MarkerButton: styled_components_1.default.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  MarkerIcon: (0, styled_components_1.default)(map_marker_icon_1.MapMarkerIcon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MarkerIconStyles),
  Popup: (0, styled_components_1.default)(map_popup_1.MapPopup)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), PopupStyles)
};
var MapMarker = function (props) {
  var className = props.className,
    zoom = props.zoom,
    maxSize = props.maxSize,
    scaleFactor = props.scaleFactor,
    children = props.children,
    isSelected = props.isSelected,
    onClick = props.onClick,
    onClose = props.onClose,
    rest = __rest(props, ["className", "zoom", "maxSize", "scaleFactor", "children", "isSelected", "onClick", "onClose"]);
  return react_1.default.createElement(react_map_gl_1.Marker, __assign({}, rest, {
    anchor: "bottom"
  }), react_1.default.createElement(My.Body, null, children && react_1.default.createElement(My.Popup, {
    className: className,
    onClose: onClose
  }, children), react_1.default.createElement(My.MarkerButton, {
    onClick: function (e) {
      onClick(e);
    }
  }, react_1.default.createElement(My.MarkerIcon, {
    isSelected: isSelected,
    zoom: zoom,
    maxSize: maxSize,
    scaleFactor: scaleFactor
  }))));
};
exports.MapMarker = MapMarker;
exports.MapMarker.defaultProps = exports.MapMarkerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;